import React from 'react';

/**
 * The meter's fixed facts, in one band.
 *
 * These replaced four icon cards that spanned the width of the page and pushed
 * the charts below the fold, one of which truncated its KPI text mid-word.
 *
 * @param {object} meter - The meter.
 * @param {string} location - Resolved location name.
 * @param {string} subLocation - Resolved sub-location name, when set.
 */
const MeterIdentityStrip = ({ meter, location, subLocation }) => {
  const facts = [
    { label: 'Meter ID', value: meter.meterId, mono: true },
    { label: 'Gateway ID', value: meter.gatewayId, mono: true },
    { label: 'Location', value: location },
    { label: 'Sub Location', value: subLocation },
    { label: 'Unit', value: meter.unit },
    { label: 'Reports', value: meter.measurementType },
    {
      label: 'Down after',
      value: meter.inactiveDurationMinutes ? `${meter.inactiveDurationMinutes} min` : null,
    },
  ];

  return (
    <dl className="im-ident">
      {facts.map((fact) => (
        <div key={fact.label}>
          <dt>{fact.label}</dt>
          <dd className={`${fact.mono ? 'im-ident-mono' : ''}${fact.value ? '' : ' im-ident-unset'}`}>
            {fact.value || 'Not set'}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default MeterIdentityStrip;
